import React from 'react';
import { useTranslation } from 'react-i18next';
import LabelButton from '../LabelButton';
import styles from './ModalFooter.module.scss';

type Props = {
  onCancel?: () => void;
  onConfirm: () => void;
  cancelLabel?: string;
  confirmLabel?: string;
  disable?: boolean;
  showCancel?: boolean;
}

const ModalFooter: React.FC<Props> = ({
  onCancel,
  onConfirm,
  cancelLabel,
  confirmLabel,
  disable,
  showCancel = true,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.footer}>
      {
        showCancel && (
          <LabelButton
            label={cancelLabel || t('cancel')}
            onClick={() => onCancel && onCancel()}
            type="normal"
            width="230px"
          />
        )
      }
      <LabelButton
        label={confirmLabel || t('confim')}
        onClick={onConfirm}
        type="square"
        width="230px"
        disable={disable}
      />
    </div>
  );
};

export default ModalFooter;
